var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`${_vm.height} ${_vm.textColor}`},[_c('div',{class:`w-full flex items-center justify-center ${_vm.isMobileScreen ? '' : 'gap-x-3'} py-2 px-2 fixed-top z-50 ${_vm.bgColor} ${_vm.height}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }